module.exports = __webpack_public_path__ + "img/career-a2.a242fd7c.jpg";